module.exports = __webpack_public_path__ + "static/remerciements-0933032a7dd6114e5632f67c4ae2b47f.jpg";